<li nz-menu-item>
  <span class="inline-flex justify-center grow-0 shrink-0 w-6 mr-4">
    <ng-content select="[icon]"></ng-content>
  </span>
  <ng-content></ng-content>
</li>
